import { ApplicationManager, Component } from "@lisergia/core";
import { Viewport } from "@lisergia/managers";
import { DOMRectBounds, DOMUtils, MathUtils } from "@lisergia/utilities";

import { autorun } from "mobx";
import sample from "lodash/sample";

export default class extends Component {
  declare element: HTMLElement;
  declare elements: {
    child: HTMLElement;
  };

  amount: number = 150;

  declare rotation: number;
  declare speed: number;

  declare child: Element;

  constructor({
    application,
    element,
  }: {
    application: ApplicationManager;
    element: HTMLElement;
  }) {
    super({
      application,
      element,
      elements: {
        child: element.firstElementChild!,
      },
    });

    autorun(this.onScroll);
  }

  declare bounds: DOMRectBounds;

  onResize() {
    this.bounds = DOMUtils.getBounds(this.element, this.application?.scroll);

    this.rotation = sample([15, 17.5, 20]);
    this.speed = sample([-0.5, -0.65, -0.7]);
  }

  onScroll() {
    if (!this.bounds) {
      return;
    }

    const scroll = this.application?.currentPage?.scroll!;

    const y = MathUtils.map(
      this.bounds.top - scroll,
      Viewport.height,
      -Viewport.height,
      -this.amount,
      this.amount,
    );

    const rotate = MathUtils.map(
      this.bounds.top - scroll,
      Viewport.height,
      -Viewport.height,
      this.rotation,
      -this.rotation,
    );

    this.elements.child.style.transform = `translate3d(0, ${y}px, 0) rotate(${rotate}deg)`;
  }

  addEventListeners() {
    Viewport.on("resize", this.onResize);
  }

  removeEventListeners() {
    Viewport.off("resize", this.onResize);
  }
}
